export default __webpack_public_path__ + "static/media/duman.832a2f7d.png";